/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2025 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2025 - Finnish Meteorological Institute (FMI)
 * Copyright 2025 - The Norwegian Meteorological Institute (MET Norway)
 * */
import type { Theme } from '@mui/material';
import React from 'react';
import { CustomIconButton } from '@opengeoweb/shared';
import type { CSSProperties } from '@opengeoweb/theme';
import { DragHandle } from '@opengeoweb/theme';

export const WarningListDragHandle: React.FC = () => {
  return (
    <CustomIconButton
      className="handle"
      disableTouchRipple
      sx={{
        '&.handle:hover': (theme: Theme): CSSProperties => ({
          ...theme.palette.geowebColors.layerManager.dragHandleHover,
        }),
        cursor: 'grab',
        marginTop: 0.5,
        paddingLeft: 0,
      }}
      tabIndex={-1}
    >
      <DragHandle />
    </CustomIconButton>
  );
};
